import React, { useContext } from 'react'
import { CallListManagerContext, Order } from '~/service/CallListManager'
import classNames from 'classnames'
import { FormattedMessage } from '~/translations/utils'

type Props = {
  width: number
}

const TableHeader: React.FC<Props> = ({ width }) => {
  const { filter, order, setFilter, setOrder } = useContext(
    CallListManagerContext
  )

  const sort = (name: Order) => {
    setOrder(name)
    setFilter({
      ...filter,
      order: name,
    })
  }

  return (
    <>
      <div className="list-table-header">
        <div className="call-list-table-header-client"></div>
        <div className="call-list-table-header-user">
          <FormattedMessage id="calls / table / header / user" />
        </div>
        {width > 1000 && (
          <>
            <div className="call-list-table-header-duration">
              <FormattedMessage id="calls / table / header / duration" />
            </div>
            <div className="call-list-table-header-recording">
              <FormattedMessage id="calls / table / header / recording" />
            </div>
            <div className="call-list-table-header-ivr">
              <FormattedMessage id="calls / table / header / ivr" />
            </div>
          </>
        )}
        <a
          className={classNames('call-list-table-header-date', {
            active: order.includes('created'),
          })}
          onClick={e => {
            e.preventDefault()
            order == 'createdDesc' ? sort('createdAsc') : sort('createdDesc')
          }}
        >
          <FormattedMessage id="calls / table / header / created" />
          {order.includes('created') && (
            <span
              className={classNames(
                'fa call-list-table-header-arrow',
                { 'fa-caret-up': order == 'createdAsc' },
                { 'fa-caret-down': order == 'createdDesc' }
              )}
            />
          )}
        </a>
      </div>
    </>
  )
}

export default TableHeader
